export default {
    //操作员
    login: "/login/WebLogin",//登录接口post
    loginMenu: "/login/WebLogin/Menu/",//返回菜单信息列表get
    AddUser: "/login/Add/User",//添加用户post
    UpdateUser: "/login/Update/User",//更新用户信息post
    AllUser: "/login/All/User/",//查询全部用户get
    DelUser: "/login/Del/User",//用户离职post
    UserUpdata: "/login/User/Up/data",//查询用户打印以及查询权限信息
    UserUpdataupdate: "/login/User/Up/data/update",//更新指定用户打印以及查询权限信息

    // 小程序用户
    getUserList: "/miniprogram/getUserList", // 获取用户列表get
    getUserDetail: "/miniprogram/getUserDetail", // 获取用户详情get
    updateUser: "/miniprogram/updateUser", // 更新用户post
    deleteUser: "/miniprogram/deleteUser", // 删除用户post
    updateUserTemplateMessage: "/miniprogram/updateUserTemplateMessage", // 更新用户模板消息post

    //销售业务员
    AddSalesPeople: "/SalesPeople/add",//添加销售人员post
    DesignatedSalesPeople: "/SalesPeople/Get/Position/Sales",//查询指定销售职位全部在职人员get
    DelSalesPeople: "/SalesPeople/Delete/Sales",//删除销售人员post
    AllSalesPeople: "/SalesPeople/GET/ALL/IN",//全部业务销售人员get
    UpdateSalesPeople: "/SalesPeople/Update",//更新单独销售人员信息post
    GETSalesPeoplehistory: "/SalesPeople/GET/History",//查询业务员转区时间get

    //客户
    Allcustom: "/custom/add",//添加客户信息post
    AllcustomIN: "/custom/GET/ALL/IN",//返回全部客户信息get
    Updatecustom: "/custom/Update",//更新客户信息post
    Delcustom: "/custom/Delete/Sales",//删除单独客户信息post
    ALLOUTcustom: "/custom/GET/ALL/OUT",//查询已删除客户信息get
    UpdateOpeningNum: "/custom//Receivable/UpdateOpeningNum",//插入或更新客户开账数

    Editcustommark: "/custom/vi/custom/mark",//编辑客户备忘录post
    Uploadcredit: "/custom/upload/custom/credit",//提交信贷审核post
    GETNOPasscredit: "/custom/GET/NOPass/custom/credit",//查询待审核信贷信息get
    UploadcreditPass: "/custom/upload/custom/credit/Pass",//信贷审核通过post

    Addcustommoney: "/custom/In/CustomMoney/Data/Pass",//录入交款记录post
    Getcustommoney: "/custom/In/CustomMoney/Data/Get",//交款记录查询get
    Delcustommoney: "/custom/In/CustomMoney/Data/DEL",//删除交款记录post

    Updatecustomdandu: "/custom/In/Custom/SalesPeople/Update",//单独更改业务员

    GetSalesPeopleModify: "/custom/In/Custom/SalesPeopleModify/Get",//业务员记录查询get

    //产品管理
    AddBigClassification: "/Classification/add",//添加大类post
    GETBigClassification: "/Classification/GET/IN",//查询大类信息+小类信息get
    UploadBigClassification: "/Classification/Update/Big",//大类品种名称，编号更新post
    DelBigClassification: "/Classification/Delete/big",//大类删除post

    AddClassification: "/Classification/add/xiao",//添加小类post
    UploadClassification: "/Classification/Update",//小类品种名称，编号更新post
    DelClassification: "/Classification/Delete",//小类删除post

    Addbrand: "/Classification/add/brand",//添加品牌post
    GETbrand: "/Classification/GET/IN/brand",//查询品牌信息get
    Uploadbrand: "/Classification/Update/Big/brand",//品牌名称，编号更新post
    Delbrand: "/Classification/Delete/big/brand",//品牌删除post

    AddProductFile: "/Classification/Add/ProductFile",//添加产品档案post
    GETProductFile: "/Classification/GET/ProductFile",//查询产品档案信息get

    UploadProductFilejson: "/Classification/Update/ProductFilejson",//待审核更新产品信息提交post
    DelProductFilejson: "/Classification/Update/DelProductFilejson",//删除待审核更新产品信息提交post
    UploadProductFile: "/Classification/Update/ProductFile",//产品档案更新post(审核的时候)
    UploadProductFileGet: "/Classification/Update/ProductFile/Get",//获取待审核更新产品信息get
    UploadPassProductFileGet: "/Classification/Update/pass/ProductFile/Get",//获取已审核更新产品信息get

    DelProductFile: "/Classification/Delete/ProductFile",//产品档案删除post

    Setcustomsetproduct: "/Classification/Set/CustomSetProduct/",//配置客户产品价格
    BatchSetcustomsetproduct: "/Classification/Batch/Set/CustomSetProduct/",//批量配置客户产品价格
    Getcustomsetproduct: "/Classification/GET/CustomSetProduct",//查询客户产品价格

    GetcustomsetproductOldMoney: "/Classification/Get/ProductFile/Old/Money/",//查询产品价格变化趋势

    //订单管理
    Getallin: "/order/GET/IN",//查询客户信息
    Getcustomsetproduct: "/order/GET/CustomSetProduct",//查询客户产品价格
    Addinorder: "/order/add/In/Order",//添加订单

    Getinorder: "/order/GET/InOrder",//查询订单
    ExportInOrder: "/order/GET/ExportInOrder",//下载对应日期的文件
    Addinorderdel: "/order/add/In/Order/Del",//订单删除
    Getinordermsg: "/order/GET/InOrder/Msg",//查询订单详情

    Addinorderone: "/order/add/In/Order/One",//订单增加一行信息
    Getinordermsgdelhang: "/order/GET/InOrder/Msg/Del/Hang",//订单删除行
    Updateinorderouttime: "/order/Update/In/Order/OutTime",//订单交货日期更新

    UpdateinorderAuditing: "/order/Update/In/Order/Auditing",//按品种核销订单
    GetinorderAuditing: "/order/GET/In/Order/Auditing",//查询已核销订单

    //配置管理
    Addconfig: "/config/addConfig",//添加配置信息
    Getconfig: "/config/getConfig",//查询配置信息
    Updateconfig: "/config/updateConfig",//更新配置信息
    Delconfig: "/config/deleteConfig",//删除配置信息

    //仓库管理
    AddStorePlan: "/store/addStorePlan",//添加计划
    GetStorePlan: "/store/getStorePlan",//生产计划查询
    GetStorePlanDetail: "/store/getStorePlanDetail",//查询某个计划下的所有记录
    DelStorePlan: "/store/deleteStorePlan",//删除某个计划里面的某行数据

    AddStorePlanItem: "/store/addStorePlanItem",//某个计划详情里面的添加一行数据
    DelStorePlanItem: "/store/getDeletedStorePlan",//已删除的计划

    SetStorePlanFinish: "/store/setStorePlanFinish",//设置计划已完成
    GetStorePlanFinish: "/store/getStorePlanFinish",//查询已完成计划

    getStorePlanFinishIn: "/store/getStorePlanFinishIn",//查询已完成计划的已进仓数据

    GetexportStorePlan: "/store/exportStorePlan",//下载对应日期的文件
    GetexportStorejinPlan: "/store/exportStorejinPlan",//下载对应日期生产日报表的文件

    UpdateStorePackagejin: "/store/updateStorePackage",//已完成的计划确认包数
    SetStorePlanIn: "/store/setStorePlanIn",//设置计划为已进仓

    GetStorePlanInWeight: "/store/getStorePlanInWeight",//统计所有产品的当日当月进仓重量 注意

    GetStorePlanInDetail: "/store/getStorePlanInDetail",//根据品种代码查询进仓详情
    getoOtherStoreDetail: "/store/getoOtherStoreDetail",//根据品种代码查询其他进仓详情

    AddOtherIn: "/store/addOtherIn",//其他进仓添加
    AddOtherOut: "/store/addOtherOut",//其他出仓添加
    GetOtherIn: "/store/getOtherIn",//查询其他进出仓
    DelOtherIn: "/store/deleteOtherIn",//删除进仓
    UpdateOtherIn: "/store/updateOtherIn",//其他进仓信息确认进仓
    UpdateOtherOut: "/store/updateOtherOut",//其他出仓信息确认出仓

    GetExportInoutStorerecord: "/store/ExportInoutStorerecord",//仓库录入录出表导出
    GetExportInStorerecord: "/store/ExportInStorerecord",//仓库录入表记录
    

    ExportInoutSummaryByDate: "/store/ExportInoutSummaryByDate",//仓库录入录出时间段查询

    UpdateStorePackage:"/store/updateStorePlanProduction",//计划查询页面，修改某一行的计划的生成数量和吨数。

    //出仓管理
    AddCheckout: "/checkout/addCheckout",//新增出仓单

    AddCheckoutItem: "/checkout/addCheckoutItem",//新增出仓单的一行
    DeleteCheckoutItem: "/checkout/deleteCheckoutItem",//删除出仓单的一行


    GetCheckoutList: "/checkout/getCheckoutList",//查询出仓单记录
    GetCheckoutDetail: "/checkout/getCheckoutDetail",//查询出仓单详情
    UpdateCheckout: "/checkout/updateCheckout",//编辑出仓单
    DeleteCheckout: "/checkout/deleteCheckout",//删除出仓单
    ConfirmCheckout: "/checkout/confirmCheckout",//仓库确认出仓
    BatchConfirmCheckout: "/checkout/batchconfirmCheckout",//仓库确认批量出仓
    GetCheckouted: "/checkout/getCheckouted",//仓库已出库记录  
    GetCheckouteddetail: "/checkout/getCheckouteddetail",//仓库已出库记录明细  

    GetDailyReport: "/checkout/Receivable/DailyReport",//应收款日报表  
    GetDailyReportRange: "/checkout/Receivable/DailyReport/Range",//应收款月报表 
    GetDailyReportRangeReconciliation: "/checkout/Receivable/Reconciliation",//客户对账单
    GetDailyReportRangeReconciliationDetail: "/checkout/Receivable/Reconciliation/Detail",//客户对账单明细
    GetDailyReportRangeMonthlyReport: "/checkout/Receivable/MonthlyReportSimple",//客户月结表
    ExecuteMonthlySettle: "/checkout/Receivable/ExecuteMonthlySettle",//执行月结按钮
    MonthlySettleHistory: "/checkout/Receivable/MonthlySettleHistory",//月结历史记录
    SalesMonthlyReport: "/checkout/Receivable/SalesMonthlyReport",//销售月度报表

    GetStock: "/checkout/getStock",//查询库存
    //退货管理
    AddReturnout: "/checkout/addReturnout",//新增退货单
    GetReturnoutList: "/checkout/getReturnoutList",//查询退货单记录
    DeleteReturnout: "/checkout/deleteReturnout",//删除退货单
    ConfirmReturnout: "/checkout/confirmReturnout",//确认退货
    UpdateCheckout: "/checkout/updateReturnout",//更新单独一条checkout记录

    //客户折扣录入管理
    AddDiscount: "/checkout/addDiscount",//新增客户折扣
    GetDiscountList: "/checkout/getDiscountList",//查询客户折扣记录
    DeleteDiscount: "/checkout/deleteDiscount",//删除客户折扣记录
    //销售综合查询
    ReceivableReportStatistics: '/checkout/Receivable/Report/Statistics',
    //销售综合查询下的按客户查询订单详细
    CustomerOrderList: '/checkout/Receivable/CustomerOrderList',
     //品种汇总查询
    ReportByBrandBreed: '/checkout/Receivable/Report/ByBrandBreed',
     //品种汇总查询详情
    ReportByBreedCustomers: '/checkout/Receivable/Report/ByBreedCustomers',
    //赠送查询汇总
    ReportByGiftStatistics: '/checkout/Receivable/Report/GiftStatistics',
    //用客户名称和时间范围查询对应的客户订单
    ReportByCustomerOrders: '/checkout/Receivable/CustomerOrders',
}
